import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem, position } from '../../../core';

const modifiers = {
  medium: () => ({
    styles: `
      strong {
        font-size: ${rem('17')};
      }
      sup {
        font-size: ${rem('10')};
        top: 0;
      }
    `,
  }),
};

export const PricingStyled = styled.span.attrs({
  className: 'component__princing',
})`
  line-height: 1;

  strong {
    font-size: ${rem(32)};
    text-align: right;
    line-height: 1;
    margin: 0;
  }

  sup {
    font-size: ${rem(15)};
    font-weight: normal;
    vertical-align: super;
    ${position('relative', '-0.1rem', '', '', '')};
  }

  small {
    display: block;
  }

  ${applyStyleModifiers(modifiers)};

`;
